import React from "react";

export function Header() {
    return (<header>Shopigent</header>);
}

export default Header